import { Text, Icon, HStack, Box } from '@chakra-ui/react';

import { IoArrowBackSharp } from 'react-icons/io5';
import Content from '~/containers/Content';

type BackwardBarProps = {
  title: string;
  onNavigate?: () => void;
};

// 固定頁面頂部的header，可點擊返回上頁
export default function BackwardBar({ title, onNavigate }: BackwardBarProps) {
  return (
    <Box as="section" bg="white" px={4}>
      <Content m="auto">
        <HStack
          onClick={onNavigate}
          zIndex="100"
          align="center"
          w="full"
          py={3}
          spacing={1}
          color="gray.500"
          bgColor="white"
          cursor="pointer"
        >
          <Icon as={IoArrowBackSharp} fontSize="xl" />
          <Text fontSize="sm" fontWeight="bold" color="gray.500">
            {title}
          </Text>
        </HStack>
      </Content>
    </Box>
  );
}
